import React from 'react';
import BackgroundImage, { imagePosition } from '../../components/BackgroundImage'

const VocaSheet = ({ imgLevelItems, vocas, lang }) => {

  const renderedVocaSheet = vocas.map((v,i) => {
    const { x, y } = imagePosition(i)
    return (
      <div className="info" key={i}>
        <div className="voca-card">
          <BackgroundImage src={imgLevelItems} posX={x} posY={y} />
        </div>
        <div className="desc">{v[lang]}</div>
      </div>
    )
  })

  return (
    <div className="wrapper">
      <div className="voca-sheet">{renderedVocaSheet}</div>
    </div>
  )
}

export default VocaSheet